// lazyload
$(function() {
  var _windowLoadedFlag = false;
  if ($('#js-layer').length) {
    // ▼プログレスバーの処理
    if (!_windowLoadedFlag) {
      var _progress = 0;
      var _imgCount = $('img').length;
      $('img').each(function(){
        var _src = $(this).attr('src');
        $('<img>').attr('src', _src).on('load',function(){
          _progress++;
        });
      });
      setInterval(function(){
        $('#js-progress-bar').css({
          'width': (_progress / _imgCount) * 100 + '%'
        });
      }, 1);
    }
    // ▼ロード時 ローディングレイヤー非表示&コンテンツ表示
    window.addEventListener('load', function() {
      if (!_windowLoadedFlag) {
        $('#js-layer').addClass('is-hidden');
        $('#js-body').addClass('is-show');
        // スクロールイベントの発火フラグ
        _windowLoadedFlag = true;
      }
    }, false);
    // ▼ロード時 3秒経ったら強制表示
    setTimeout(function() {
      if (!_windowLoadedFlag) {
        $('#js-layer').addClass('is-hidden');
        $('#js-body').addClass('is-show');
        // スクロールイベントの発火フラグ
        _windowLoadedFlag = true;
        console.log('loading timeout');
      }
    }, 3000);
  }

  // loading
  // var imgNum = imagesLoaded('body').images.length;
  // var loadedImg = 0;
  // var progressNowPosition = 0;
  // Timer = setInterval(progressMonitor, 1000/50);
  // imagesLoaded('body').on('progress', function(){
  //   loadedImg++;
  // });
  // function progressMonitor(){
  //   var progressPosition = (loadedImg/imgNum) * 100;
  //   progressNowPosition += (progressPosition-progressNowPosition) * 0.1;
  //   $('#progressBar').css('width', progressNowPosition+'%');
  //   if(progressNowPosition >= 100){
  //     clearInterval(Timer);
  //     $('#progress').fadeOut(1000, function(){
  //     });
  //   }
  //   if(progressNowPosition > 99.9){
  //       progressNowPosition = 100;
  //   }
  // }
});
